module.exports = __webpack_public_path__ + "static/media/18ECA51.9ad30e1b.jpg";